import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Fires a SPA page_view to Google Analytics on every route change.
 * Also exposes window.trackEvent(name, params) for custom conversions
 * (e.g. booking submission, WhatsApp click).
 */
export function useAnalytics() {
  const location = useLocation();

  useEffect(() => {
    if (typeof window === "undefined" || typeof window.gtag !== "function") return;
    const id = window.__GA_ID__;
    if (!id) return;
    window.gtag("event", "page_view", {
      page_path: location.pathname + location.search + location.hash,
      page_location: window.location.href,
      page_title: document.title,
      send_to: id,
    });
  }, [location]);
}

export function trackEvent(name, params = {}) {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  window.gtag("event", name, params);
}
